var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighRewardAdIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000005192",
    clipPath: "url(#clip0_0_9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon (Stroke)",
    d: "M13.7334 4C13.7333 3.04283 12.9569 2.26693 11.9997 2.26693H3.99967C3.04259 2.26707 2.26674 3.04291 2.2666 4V12C2.2666 12.9572 3.0425 13.7336 3.99967 13.7337H11.9997C12.957 13.7337 13.7334 12.9573 13.7334 12V4ZM5.90853 4.23372C6.32506 4.0393 6.76541 4.15294 7.0791 4.35156L7.09928 4.36393L7.11816 4.37826L10.7764 7.07161C11.0684 7.25056 11.4176 7.57024 11.4183 8.06706C11.4189 8.56315 11.0674 8.89464 10.7809 9.08529L10.7816 9.08594L7.14811 11.6276L7.11947 11.6471L7.08887 11.6641C6.79168 11.8285 6.33358 11.9824 5.89355 11.7474C5.44662 11.5087 5.32296 11.0333 5.30176 10.6771L5.30046 10.6589V10.64L5.28483 5.32096L5.28548 5.32031C5.28038 4.89271 5.45944 4.44341 5.90853 4.23372ZM6.63249 10.36L9.89486 8.07878L6.61882 5.66667L6.63249 10.36ZM15.0667 12C15.0667 13.6937 13.6933 15.0671 11.9997 15.0671H3.99967C2.30612 15.0669 0.933268 13.6936 0.933268 12V4C0.933409 2.30653 2.30621 0.933734 3.99967 0.933594H11.9997C13.6933 0.933594 15.0666 2.30645 15.0667 4V12Z",
    fill: "var(--fill-0, white)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighRewardAdIcon);
export default __webpack_public_path__ + "static/media/high-reward-ad-icon.7fd823039dc4d2693070b95058265b2a.svg";
export { ForwardRef as ReactComponent };